var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.328,
    height: 20.328,
    viewBox: "0 0 20.328 20.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.164,0A10.165,10.165,0,0,0,1.348,15.224L.038,19.29a.794.794,0,0,0,1,1L5.1,18.98A10.164,10.164,0,1,0,10.164,0Zm0,18.74a8.551,8.551,0,0,1-4.539-1.3.8.8,0,0,0-.664-.083L2.025,18.3l.945-2.936a.8.8,0,0,0-.083-.664,8.576,8.576,0,1,1,7.277,4.037Zm.993-8.576a.993.993,0,1,1-.993-.993A.993.993,0,0,1,11.157,10.164Zm3.97,0a.993.993,0,1,1-.993-.993A.993.993,0,0,1,15.127,10.164Zm-7.941,0a.993.993,0,1,1-.993-.993A.993.993,0,0,1,7.186,10.164Zm0,0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.63a5b3f2248db7f88ecbd8914f5b6b6a.svg";
export { ForwardRef as ReactComponent };